import { Link, RouteComponentProps } from '@reach/router'
import { Layout } from 'antd'
import React from 'react'
import styled from 'styled-components'
import hero from '../assets/hero.jpg'
import { ROOT_PATH, USER_SESSION_EKY } from '../common/config'
import { ForgotPassword, ForgotPasswordProvider } from '../components/ForgotPassword'
import { ForgotProvider } from '../components/ForgotUser'
import { Brand, HeroIntro } from '../components/ui'

const { Sider, Content } = Layout

const StyledUser = styled.div`
  h1 {
    font-weight: 500;
    font-size: 32px !important;
    line-height: 38px;
    color: #262626;
    margin-top: 120px;
    margin-bottom: 100px;
  }

  .user-left {
    background: linear-gradient(rgba(77, 70, 70, 0.3), rgba(77, 70, 70, 0.3)), url(${hero}) no-repeat center / cover;
  }

  .user-content {
    height: calc(var(--vh) * 100);
    width: 100%;
    padding: 0 120px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  .btn-groups {
    margin-top: auto;
    width: 100%;
  }
`

export const Reset: React.FC<RouteComponentProps> = () => {
  const userInfo = JSON.parse(sessionStorage.getItem(USER_SESSION_EKY) || '{}')

  return (
    <ForgotProvider>
      <ForgotPasswordProvider username={userInfo.username}>
        <StyledUser>
          <Layout className="page h-mscreen">
            <Sider width="50%" className="user-left">
              <HeroIntro />
            </Sider>
            <Content className="user-content">
              <Link to={ROOT_PATH}>
                <Brand />
              </Link>
              <ForgotPassword />
            </Content>
          </Layout>
        </StyledUser>
      </ForgotPasswordProvider>
    </ForgotProvider>
  )
}
